// Four cohesive theme variants. One is picked on mount.
export const THEMES = [
  {
    id: 'cobalt',
    name: 'COBALT // CYBER YELLOW',
    primary: '#2563eb',
    primaryGlow: 'rgba(37, 99, 235, 0.45)',
    accent: '#eab308',
  },
  {
    id: 'amber',
    name: 'AMBER // CRIMSON',
    primary: '#ea580c',
    primaryGlow: 'rgba(234, 88, 12, 0.45)',
    accent: '#dc2626',
  },
  {
    id: 'emerald',
    name: 'EMERALD // CHARTREUSE',
    primary: '#059669',
    primaryGlow: 'rgba(5, 150, 105, 0.45)',
    accent: '#d9f99d',
  },
  {
    id: 'international-orange',
    name: 'INTL ORANGE // ASH',
    primary: '#ff4f00',
    primaryGlow: 'rgba(255, 79, 0, 0.45)',
    accent: '#9ca3af',
  },
];

export function pickRandomTheme() {
  return THEMES[Math.floor(Math.random() * THEMES.length)];
}

export function applyTheme(theme) {
  const root = document.documentElement;
  root.style.setProperty('--theme-primary', theme.primary);
  root.style.setProperty('--theme-primary-glow', theme.primaryGlow);
  root.style.setProperty('--theme-accent', theme.accent);
  root.style.setProperty('--theme-name', `'${theme.name}'`);
}
